export type Enum<E> = Record<string, E | string> & Record<number, string>;

export function enumToArray<E>(enumType: Enum<E>) {
  return Object.values(enumType).filter(x => typeof (x) !== 'string') as E[];
}
